import { render } from "./VacanciesForm.vue?vue&type=template&id=82b77346&scoped=true"
import script from "./VacanciesForm.vue?vue&type=script&lang=js"
export * from "./VacanciesForm.vue?vue&type=script&lang=js"

import "./VacanciesForm.vue?vue&type=style&index=0&id=82b77346&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82b77346"]])

export default __exports__